import React from 'react';
import { Link } from 'react-router-dom';
import { HeartHandshakeIcon } from 'lucide-react';
import { focusRing } from '../../utils/styles';
interface LogoProps {
  tone?: 'dark' | 'light';
}
export function Logo({
  tone = 'dark'
}: LogoProps) {
  const light = tone === 'light';
  return <Link to="/" className={`flex shrink-0 items-center gap-3 rounded-lg ${focusRing}`} aria-label="A.M. Home Care, Inc. home" data-id="element-195" data-mp="ocyu1iq3gonf">
      <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${light ? 'bg-white text-brand' : 'bg-brand text-white'}`} aria-hidden="true" data-id="element-196" data-mp="kcohtobpl204">
        <HeartHandshakeIcon className="h-6 w-6" strokeWidth={2} data-id="element-197" data-mp="allesgz7ycy7" />
      </span>
      <span className="flex flex-col leading-tight" data-id="element-198" data-mp="5njw3x5pgfn9">
        <span className={`font-display text-lg font-bold ${light ? 'text-white' : 'text-ink'}`} data-id="element-199" data-mp="n4ir5lfb85a">
          A.M. Home Care
        </span>
        <span className={`text-xs font-medium ${light ? 'text-white/75' : 'text-ink-soft'}`} data-id="element-200" data-mp="3srzqe9a0matf">
          Inc. · Woodbridge, VA
        </span>
      </span>
    </Link>;
}